import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * ValidationErrorsTable component displays a table of validation errors for user import.
 * @component
 * @param {Object[]} errors - Array of validation error objects.
 * @param {number} errors[].row - The row number in the Excel file where the error occurred.
 * @param {string} errors[].email - The email address associated with the row.
 * @param {string[]} errors[].errors - Array of error messages for the row.
 * @returns {JSX.Element|null} A table of validation errors, or null if there are no errors.
 */

const ValidationErrorsTable = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 className="text-danger">Validation Errors</h6>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Row</th>
            <th>Email</th>
            <th>Errors</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index}>
              <td>{error.row}</td>
              <td>{error.email}</td>
              <td>
                <ul className="mb-0 pl-3">
                  {error.errors.map((err, i) => (
                    <li key={i}>{err}</li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ValidationErrorsTable;
